import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as usersActions from 'Store/users/actions';
import * as reducers from 'Store/reducers';

import Loading from 'Components/Loading';
import SectionHeader from 'Components/SectionHeader';
import Form from 'Components/Form';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

function ChangePasswordForm(props) {
  const { activeUser } = props;
  if (!activeUser) return <Loading />;
  return (
    <div>
      <SectionHeader
        title={<ConnectedFormattedMessage id="change_password_page.title" />}
        type="static-modal"
      />
      <Form
        type="changePassword"
        id="changePassword"
        formStyle="change-password"
        messagePosition="content-frame"
        submitArgs={{ id: activeUser.id }}
        initialFieldSettings={{
          username: { value: activeUser.auth_info.username },
        }}
        hideOptionalFlags
        submitButtonType="primary"
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    activeUser: reducers.getActiveUser(state),
  };
};

export default withRouter(
  connect(mapStateToProps, usersActions)(ChangePasswordForm)
);
